/*
 * Pay-now offer + split checkout (Supernova 8.5+). Config comes from snippets/spark-paynow.liquid.
 * Pay now = the "Prepaid" shipping rate is free (store setting) — no discount code involved.
 *
 * Cart attribute `payment_mode` is the only marker Payflow reads:
 *   prepaid → Payflow hides COD      cod → Payflow may hide card methods (rule optional)
 * Split orders also carry `split_group_id` (shared by both halves) and `split_role` (prepaid|cod).
 *
 * The customer's cart is never touched by the split: each half is a fresh Storefront API cart (tokenless
 * cartCreate) built from its own line list; the prepaid half opens through a real <a target="_blank"> (built
 * when "Split" is picked) because Safari blocks window.open('') + a later navigation. Cart permalinks (/cart/<id>:<qty>) are NOT used: they replace
 * the session cart (tested 22 Oct 2026).
 */
(function () {
  var C = window.SparkPaynow;
  if (!C || !C.enabled) return;
  var T = C.copy;
  var busy = false;

  function fmt(s, v) {
    return String(s || '').replace(/\{(\w+)\}/g, function (_, k) { return v && v[k] != null ? v[k] : ''; });
  }
  function money(cents) {
    var n = (cents / 100).toFixed(2), parts = n.split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return C.moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, int)
      .replace(/\{\{\s*amount\s*\}\}/, int + '.' + parts[1])
      .replace(/\{\{\s*\w+\s*\}\}/, int + '.' + parts[1]);
  }
  // thresholds read better without the decimals: LE 2,500 not LE 2,500.00
  function moneyRound(cents) { return money(cents).replace(/[.,]00(?=\D*$)/, ''); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function json(url, body) {
    return fetch(url, body ? {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    } : { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  var PREPAID_TYPES = C.prepaidTypes.map(function (t) { return t.toLowerCase(); });
  function isPrepaidOnly(item) { return PREPAID_TYPES.indexOf(String(item.product_type || '').toLowerCase()) !== -1; }

  function classify(cart) {
    var po = [], cod = [];
    cart.items.forEach(function (it) { (isPrepaidOnly(it) ? po : cod).push(it); });
    var kind = !cart.items.length ? 'empty' : po.length ? (cod.length ? 'mixed' : 'prepaid') : 'cod';
    return { kind: kind, po: po, cod: cod };
  }
  function sum(items) { return items.reduce(function (n, it) { return n + it.final_line_price; }, 0); }
  function names(items) {
    var t = items.map(function (it) { return it.product_title; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
    return t.length > 1 ? t.slice(0, -1).join(', ') + ' & ' + t[t.length - 1] : t[0] || '';
  }

  /* customer-entered codes currently on the cart: kept as they are (pay now needs no code any more) */
  function codesWith(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable !== false; })
      .map(function (d) { return d.code; }).join(',');
  }

  function setMode(cart, mode) {
    var attrs = { payment_mode: mode };
    // a one-order checkout is never part of a split
    if (cart.attributes && cart.attributes.split_group_id) { attrs.split_group_id = ''; attrs.split_role = ''; }
    return json('/cart/update.js', { attributes: attrs, discount: codesWith(cart) });
  }
  function goCheckout() { window.location.href = '/checkout'; }

  /* ---------- sheet ---------- */
  var root;
  function sheet(html, foot) {
    close();
    root = document.createElement('div');
    root.className = 'spn-scrim';
    root.setAttribute('dir', C.rtl ? 'rtl' : 'ltr');
    // body scrolls, foot (the CTA) stays on screen
    root.innerHTML = '<div class="spn-sheet" role="dialog" aria-modal="true" aria-labelledby="spn-title">' +
      '<button type="button" class="spn-x" data-spn="close" aria-label="' + esc(T.close) + '">&times;</button>' +
      '<div class="spn-body">' + html + '<p class="spn-err" role="alert" hidden></p></div>' +
      (foot ? '<div class="spn-foot">' + foot + '</div>' : '') + '</div>';
    document.body.appendChild(root);
    document.documentElement.classList.add('spn-lock');
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    var f = root.querySelector('.spn-btn'); if (f) f.focus();
  }
  function close() {
    // the cart changed under the sheet (prepaid items removed): show the page as it now is
    if (root && root.dataset.reload) return window.location.reload();
    if (root) root.remove();
    root = null; busy = false;
    document.documentElement.classList.remove('spn-lock');
  }
  function fail(e) {
    busy = false;
    if (window.console) console.error('[spark-paynow]', e);
    if (!root) return;
    var p = root.querySelector('.spn-err'); p.textContent = T.error; p.hidden = false;
    root.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
  }
  function lock() { busy = true; root.querySelectorAll('button').forEach(function (b) { b.disabled = true; }); }

  function trustRow() {
    var tpl = document.getElementById('spn-paylogos');
    return '<span class="spn-trust">' + (tpl ? '<span class="spn-logos">' + tpl.innerHTML + '</span>' : '') +
      '<span>' + esc(T.trust_line) + '</span></span>';
  }

  /* Pay now = free shipping (a shipping code, so it stacks with any product/order discount). */
  function offerSheet(cart, c) {
    var total = cart.total_price;
    // above the COD cap COD is off at checkout: say so up front instead of offering a choice
    if (C.codMax && total > C.codMax * 100) return overLimitSheet(cart, c);
    // from the store-wide free-shipping threshold COD ships free too: the pull is speed + insurance, not shipping
    var freeAll = C.freeOver && total >= C.freeOver * 100;
    var v = { total: money(total), free: moneyRound(C.freeOver * 100), max: moneyRound(C.codMax * 100) };
    // the price column is the shipping: Free vs the zone range (or Free vs Free above the threshold)
    sheet(
      '<p class="spn-eyebrow">' + esc(T.offer_eyebrow) + '</p>' +
      '<h2 class="spn-h" id="spn-title">' + esc(freeAll ? T.offer_title_free : T.offer_title) + '</h2>' +
      '<div class="spn-opts" role="radiogroup">' +
        '<label class="spn-opt spn-sel"><input type="radio" name="spn-pay" value="prepaid" checked>' +
          '<span><b>' + esc(T.paynow_label) + '</b><small>' + esc(fmt(T.paynow_sub, v)) + '</small>' + trustRow() + '</span>' +
          '<span class="spn-amt spn-free">' + esc(T.amt_free) + '</span></label>' +
        '<label class="spn-opt"><input type="radio" name="spn-pay" value="cod">' +
          '<span><b>' + esc(T.cod_label) + '</b><small>' + esc(fmt(freeAll ? T.cod_sub_free : T.cod_sub, v)) + '</small></span>' +
          '<span class="spn-amt' + (freeAll ? ' spn-free' : '') + '">' + esc(freeAll ? T.amt_free : T.amt_cod) + '</span></label>' +
      '</div>' +
      '<p class="spn-ship">' + esc(fmt(freeAll ? T.shipping_note_free : T.shipping_note, v)) + '</p>',
      '<button type="button" class="spn-btn" data-spn="go">' + esc(T.paynow_cta) + '</button>'
    );
    root.addEventListener('change', function (e) {
      if (e.target.name !== 'spn-pay') return;
      root.querySelectorAll('.spn-opt').forEach(function (l) { l.classList.toggle('spn-sel', l.contains(e.target)); });
      root.querySelector('[data-spn="go"]').textContent = e.target.value === 'cod' ? T.cod_cta : T.paynow_cta;
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-spn]'); if (!a || busy) return;
      if (a.dataset.spn === 'close') return close();
      if (a.dataset.spn === 'go') {
        var prepaid = root.querySelector('input[name="spn-pay"]:checked').value === 'prepaid';
        lock();
        setMode(cart, prepaid ? 'prepaid' : 'cod').then(goCheckout).catch(fail);
      }
    });
  }

  /* Over the COD cap: no choice to make, so explain why (courier cash limit = the customer's safety) and
     send them on with the pay-now free shipping. */
  function overLimitSheet(cart, c) {
    var v = { total: money(cart.total_price), max: moneyRound(C.codMax * 100) };
    sheet(
      '<p class="spn-eyebrow">' + esc(T.offer_eyebrow) + '</p>' +
      '<h2 class="spn-h" id="spn-title">' + esc(fmt(T.over_title, v)) + '</h2>' +
      '<p class="spn-ship">' + esc(fmt(T.over_why, v)) + '</p>' +
      '<div class="spn-opts">' +
        '<div class="spn-opt spn-sel spn-opt--solo">' +
          '<span><b>' + esc(T.paynow_label) + '</b><small>' + esc(fmt(T.paynow_sub, v)) + '</small>' + trustRow() + '</span>' +
          '<span class="spn-amt spn-free">' + esc(T.amt_free) + '</span></div>' +
      '</div>',
      '<button type="button" class="spn-btn" data-spn="go">' + esc(T.over_cta) + '</button>' +
      '<button type="button" class="spn-link spn-back" data-spn="close">' + esc(T.over_back) + '</button>'
    );
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-spn]'); if (!a || busy) return;
      if (a.dataset.spn === 'close') return close();
      if (a.dataset.spn === 'go') { lock(); setMode(cart, 'prepaid').then(goCheckout).catch(fail); }
    });
  }

  /* ---------- split ---------- */
  function splitId(cart) {
    var k = 'spn-split-' + cart.token, id = null;
    try { id = sessionStorage.getItem(k); } catch (e) {}
    if (!id) {
      var a = new Uint8Array(6); crypto.getRandomValues(a);
      id = 'SG-' + Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('').toUpperCase();
      try { sessionStorage.setItem(k, id); } catch (e) {}
    }
    return id;
  }

  /* Each failure becomes a short code ("HTTP 403", "NET TypeError", "UE INVALID") shown under the split
     button, so a screenshot from a phone says what went wrong. */
  function storefront(query, variables) {
    var h = { 'Content-Type': 'application/json', Accept: 'application/json' };
    // tokenless access covers cartCreate; a public token (theme setting) only raises rate limits
    if (C.storefrontToken) h['X-Shopify-Storefront-Access-Token'] = C.storefrontToken;
    return fetch('/api/' + C.storefrontVersion + '/graphql.json', {
      method: 'POST', credentials: 'same-origin', headers: h, body: JSON.stringify({ query: query, variables: variables })
    }).catch(function (e) {
      throw new Error('NET ' + (e && (e.name + ' ' + e.message) || e));
    }).then(function (r) {
      return r.text().then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (x) {}
        if (!r.ok || !j) throw new Error('HTTP ' + r.status + (j ? '' : ' ' + t.slice(0, 60).replace(/\s+/g, ' ')));
        if (j.errors && j.errors.length) throw new Error('GQL ' + (j.errors[0].message || '').slice(0, 80));
        return j;
      });
    });
  }

  var CART_CREATE = 'mutation($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { field message code } } }';

  function lineInput(it) {
    var props = it.properties || {}, attrs = [];
    Object.keys(props).forEach(function (k) { if (props[k] != null && props[k] !== '') attrs.push({ key: k, value: String(props[k]) }); });
    var l = { merchandiseId: 'gid://shopify/ProductVariant/' + it.variant_id, quantity: it.quantity };
    if (attrs.length) l.attributes = attrs;
    return l;
  }

  /* One half of a split → checkout URL. Prepaid half gets the pay-now free-shipping code, so shipping
     is paid once: on the cash-on-delivery half. */
  function halfUrl(cart, role, items) {
    var prepaid = role === 'prepaid';
    return storefront(CART_CREATE, { input: {
      lines: items.map(lineInput),
      attributes: [
        { key: 'payment_mode', value: prepaid ? 'prepaid' : 'cod' },
        { key: 'split_group_id', value: splitId(cart) },
        { key: 'split_role', value: role }
      ],
      discountCodes: []
    } }).then(function (r) {
      var cc = r && r.data && r.data.cartCreate;
      var ue = cc && cc.userErrors && cc.userErrors[0];
      if (ue) throw new Error('UE ' + (ue.code || '') + ' ' + (ue.message || '').slice(0, 80));
      if (!cc || !cc.cart || !cc.cart.checkoutUrl) throw new Error('EMPTY ' + JSON.stringify(r).slice(0, 80));
      return cc.cart.checkoutUrl;
    });
  }

  /* Mixed cart (prepaid-only + COD-eligible): pay all now · split into two orders · remove the prepaid items */
  function splitSheet(cart, c) {
    var v = { po: names(c.po), cod: names(c.cod) };
    var CTA = { all: T.mix_all_cta, split: T.mix_split_cta, drop: T.mix_drop_cta };
    function opt(val, label, sub, amt, extra, checked) {
      return '<label class="spn-opt' + (checked ? ' spn-sel' : '') + '"><input type="radio" name="spn-mix" value="' + val + '"' + (checked ? ' checked' : '') + '>' +
        '<span><b>' + esc(fmt(label, v)) + '</b><small>' + esc(fmt(sub, v)) + '</small>' + (extra || '') + '</span>' +
        '<span class="spn-amt' + (amt === T.amt_free ? ' spn-free' : '') + '">' + esc(amt) + '</span></label>';
    }
    sheet(
      '<p class="spn-eyebrow">' + esc(T.offer_eyebrow) + '</p>' +
      '<h2 class="spn-h" id="spn-title">' + esc(T.split_title) + '</h2>' +
      '<p class="spn-ship">' + esc(fmt(T.split_why, v)) + '</p>' +
      '<div class="spn-opts" role="radiogroup">' +
        opt('all', T.mix_all_label, T.mix_all_sub, T.amt_free, trustRow(), true) +
        opt('split', T.mix_split_label, T.mix_split_sub, T.amt_cod) +
        opt('drop', T.mix_drop_label, T.mix_drop_sub, T.amt_cod) +
      '</div>' +
      '',
      '<button type="button" class="spn-btn" data-spn="go">' + esc(CTA.all) + '</button>' +
      '<a class="spn-btn spn-split-go" data-spn="split-open" href="#" target="_blank" rel="noopener" hidden></a>' +
      '<p class="spn-diag" hidden></p>' +
      '<p class="spn-note">' + esc(fmt(T.split_tabs_note, v)) + '</p>'
    );
    var note = root.querySelector('.spn-note'), go = root.querySelector('[data-spn="go"]'), link = root.querySelector('.spn-split-go');
    var diag = root.querySelector('.spn-diag');
    var prep = null, codUrl = null;
    note.hidden = true;

    // both checkouts are built before the tap, so the tap is a plain link click (never blocked)
    function prepare() {
      if (prep) return prep;
      // one after the other, each retried once after a short pause
      function once(role, items) {
        return halfUrl(cart, role, items).catch(function () {
          return new Promise(function (ok) { setTimeout(ok, 700); }).then(function () { return halfUrl(cart, role, items); });
        });
      }
      var poUrl;
      prep = once('prepaid', c.po)
        .then(function (u) { poUrl = u; return once('cod', c.cod); })
        .then(function (u) { codUrl = u; return poUrl; });
      prep.catch(function () { prep = null; });
      return prep;
    }
    function showSplit(on) {
      go.hidden = on; link.hidden = !on; note.hidden = !on; diag.hidden = true;
      if (!on) return;
      link.setAttribute('aria-disabled', 'true'); link.removeAttribute('href'); link.textContent = T.mix_split_prep;
      prepare().then(function (poUrl) {
        if (link.hidden) return;
        link.href = poUrl; link.removeAttribute('aria-disabled'); link.textContent = CTA.split;
      }).catch(function (err) {
        if (window.console) console.error('[spark-paynow]', err);
        link.textContent = T.error;
        diag.textContent = String(err && err.message || err).slice(0, 120);
        diag.hidden = false;
        // also surfaces in analytics tools that record JS errors (Clarity)
        setTimeout(function () { throw new Error('[spark-paynow split] ' + diag.textContent + ' | ' + navigator.userAgent.slice(0, 80)); });
      });
    }
    root.addEventListener('change', function (e) {
      if (e.target.name !== 'spn-mix') return;
      root.querySelectorAll('.spn-opt').forEach(function (l) { l.classList.toggle('spn-sel', l.contains(e.target)); });
      go.textContent = CTA[e.target.value] || CTA.all;
      showSplit(e.target.value === 'split');
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-spn]'); if (!a || busy) return;
      var act = a.dataset.spn;
      if (act === 'close') return close();
      if (act === 'go') act = root.querySelector('input[name="spn-mix"]:checked').value;

      if (act === 'all') { lock(); return setMode(cart, 'prepaid').then(goCheckout).catch(fail); }

      if (act === 'drop') {
        lock();
        var updates = {}; c.po.forEach(function (it) { updates[it.key] = 0; });
        // then straight into the normal pay-now choice for what's left
        return json('/cart/update.js', { updates: updates }).then(function () { return json('/cart.js'); })
          .then(function (left) { busy = false; offerSheet(left, classify(left)); if (root) root.dataset.reload = '1'; }).catch(fail);
      }

      if (act === 'split-open') {
        // the link itself opens the prepaid checkout in a new tab; this tab moves on to the COD half
        if (a.getAttribute('aria-disabled') === 'true' || !a.getAttribute('href')) return e.preventDefault();
        setTimeout(function () { if (codUrl) window.location.href = codUrl; }, 250);
      }
    });
  }

  /* ---------- checkout intercept ---------- */
  function onCheckout(e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn || btn.disabled) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    json('/cart.js').then(function (cart) {
      busy = false;
      var c = classify(cart);
      if (c.kind === 'empty') return;
      if (c.kind === 'cod') return offerSheet(cart, c);
      // mixed: splitting or dropping only helps if the COD part fits under the COD cap
      if (c.kind === 'mixed') return C.codMax && sum(c.cod) > C.codMax * 100 ? overLimitSheet(cart, c) : splitSheet(cart, c);
      // prepaid-only: no popup, no pay-now code
      busy = true;
      return setMode(cart, 'prepaid').then(goCheckout);
    }).catch(function (err) {
      busy = false;
      if (window.console) console.error('[spark-paynow]', err);
      // never strand the customer: fall back to the theme's own checkout
      btn.form ? btn.form.submit() : goCheckout();
    });
  }
  document.addEventListener('click', onCheckout, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && !busy) close(); });

  /* ---------- switch back (cart page; reached from checkout's cart link) ---------- */
  function switchBanner() {
    if (!C.isCartPage || C.mode !== 'prepaid') return;
    var anchor = document.querySelector('.cart__ctas') || document.querySelector('#main-cart-footer');
    if (!anchor) return;
    json('/cart.js').then(function (cart) {
      var d = document.createElement('div');
      d.className = 'spn-switch';
      d.innerHTML = '<span>' + esc(T.switch_text) + '</span><button type="button" class="spn-link">' + esc(T.switch_link) + '</button>';
      anchor.parentNode.insertBefore(d, anchor);
      d.querySelector('button').addEventListener('click', function (ev) {
        ev.target.disabled = true;
        setMode(cart, 'cod').then(function () { window.location.reload(); })
          .catch(function () { ev.target.disabled = false; });
      });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', switchBanner); else switchBanner();
})();
